import React from "react";
import { Link } from "react-router-dom";
import { useCurrency } from "../context/CurrencyContext";
import { resolveMediaUrl } from "../lib/api";

const ProductCard = ({ product, index = 0 }) => {
  const { formatPrice } = useCurrency();
  const onSale = typeof product.sale_price === "number"
    && product.sale_price > 0
    && product.sale_price < product.price_100ml;
  const discountPct = onSale
    ? Math.round(((product.price_100ml - product.sale_price) / product.price_100ml) * 100)
    : 0;

  return (
    <Link
      to={`/parfum/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="product-card group block relative reveal"
      style={{ animationDelay: `${index * 120}ms` }}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-[#0A0A0A]">
        <img
          src={resolveMediaUrl(product.image_main)}
          alt={product.name}
          loading="lazy"
          className="product-image w-full h-full object-cover"
        />
        {product.badge && !onSale && (
          <span
            data-testid={`product-badge-${product.slug}`}
            className="absolute top-4 left-4 label-caps text-black bg-[color:var(--gold)] px-3 py-1.5 text-[9px]"
          >
            {product.badge}
          </span>
        )}
        {onSale && (
          <span
            data-testid={`product-sale-badge-${product.slug}`}
            className="absolute top-4 left-4 label-caps text-white bg-red-600 px-3 py-1.5 text-[9px] shadow-lg"
          >
            Solde −{discountPct}%
          </span>
        )}
      </div>
      <div className="pt-6 pb-2 flex items-start justify-between gap-4">
        <div>
          <p className="label-caps text-white/40 mb-2">{product.brand || product.category}</p>
          <h3 className="product-title font-serif text-2xl text-white">{product.name}</h3>
          <p className="text-sm text-white/50 mt-1 italic">{product.tagline}</p>
        </div>
        <div className="text-right whitespace-nowrap">
          {onSale ? (
            <>
              <p className="font-serif text-xl text-red-400">{formatPrice(product.sale_price)}</p>
              <p className="label-caps text-white/40 text-[10px] mt-1 line-through">{formatPrice(product.price_100ml)}</p>
            </>
          ) : (
            <>
              <p className="font-serif text-xl text-[color:var(--gold)]">{formatPrice(product.price_100ml)}</p>
              {product.product_type !== "watch" && (
                <p className="label-caps text-white/40 text-[10px] mt-1">100 ml</p>
              )}
            </>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
